export default __webpack_public_path__ + "static/media/2022-09-06-twitter-copyright-claims-policy.63c23612.md";